import { render, staticRenderFns } from "./ExternalPage.vue?vue&type=template&id=461d635e&scoped=true&"
import script from "./ExternalPage.vue?vue&type=script&lang=js&"
export * from "./ExternalPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461d635e",
  null
  
)

export default component.exports